import React from 'react';
import { motion } from "framer-motion";
import hero from '../../Assets/images/circle-herog.png';
import Bg from '../../Assets/images/saveS.png';
import Bgs from '../../Assets/images/saveB.png';
import Star from '../../Assets/images/star.svg';
import Constant from '../../Constant';
import I1 from '../../Assets/images/si1.svg';
import I2 from '../../Assets/images/si2.png';
import I3 from '../../Assets/images/si3.png';
import Tcom from './Tcom';
import Button from '../SelectValue/Button';

function TopSec() {
  return (
    <div className="relative overflow-hidden body-bg ">
      <div className="pt-[140px] sm:pt-[177px] grid sm:grid-cols-3 gap-4">
        <div className="md:col-span-2 mb-10 px-6 sm:px-24">
          

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-[24px] mb-6 font-[24px] text-text-color1 sm:text-[48px]"
          >
            Save Together.
            <span className={Constant.linearColor}> Grow Together.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]"
          >
            Join a Circle - a smarter, Shariah-compliant way to pool money, invest ethically, and grow as a community. No riba, just shared prosperity.          
            </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <div className="flex flex-col sm:flex-row gap-4">
              <Button name="Join Circle " />
            </div>
          </motion.div>
        </div>

        <div className="relative px-10 sm:pt-20">
          <motion.img
            src={hero}
            alt="home"
            className="hidden md:block w-full h-auto"
            initial={{ opacity: 0, x: 100 }}
            animate={{
              opacity: 1,
              x: 0,
              y: [0],
            }}
            transition={{
              opacity: { duration: 1, ease: "easeOut" },
              x: { duration: 1, ease: "easeOut" },
              y: { duration: 3, repeat: Infinity, ease: "easeInOut" },
            }}
          />

          <motion.img
            src={hero}
            alt="home"
            className="md:hidden block w-full h-auto"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          />

          
        </div>
      </div>
    </div>
  );
}

export default TopSec;



